
import api from "~api";
import setting from '../../server/settings'
import XHeader from 'vux/src/components/x-header/index.vue'
import Selector from 'vux/src/components/selector/index.vue'

export default {
name: "search-score",
components: {
XHeader,Selector
},
mounted(){
var _this = this;
_this.$vux.loading.show({
text: 'Loading'
})
api.post('/getyearandterm',{"stuNumber ": _this.$store.state.stu_num, "idCard":_this.$store.state.stu_idcard})
.then(function (response) {
var data = response.data;
var length = data.data.length;
if (data.code == "0"){
if(data.data.length>0){
for(var i = 0;i<length;i++){
var tmp = {
key:i,
value:data.data[length-1-i]
};
_this.termlist.push(tmp);
}
_this.currentterm = _this.termlist[0].key;
_this.$vux.loading.hide()

}else {
_this.$msgbox('温馨提示',"当前没有可查询的学期");
}
}
})

},
data(){
return{
currentterm:'',
year:'',
term:'',
semesters: [],
hasData: true,
termlist:[],
yourscore:[
]
}
},
methods:{
onChange (val) {
var _this = this;
_this.currentterm = val;
_this.getScore();
},
goHome(){
var _this= this;
_this.$router.push({name: 'home'});
},

getScore () {
var _this = this;
_this.$vux.loading.show({
text: 'Loading'
})
_this.yourscore = [];
for(var i = 0;i<_this.termlist.length;i++){
if(_this.currentterm ==parseInt(_this.termlist[i].key)){
_this.year = _this.termlist[i].value.split('-')[0];
var index = _this.termlist[i].value.indexOf('第');
var tmp = _this.termlist[i].value.slice(index+1,index+2);
_this.term = tmp=='一'?'1':'2';
}
}
api.post('/getSocre',{"stuNumber":_this.$store.state.stu_num,"idCard": _this.$store.state.stu_idcard,"year":_this.year,"term":_this.term})
.then(function (response) {
var data = response.data;
if (data.code == "0"){
if(data.data.length>0){
for(var i = 0 ;i<data.data.length;i++){
var tmp = {
courseName:data.data[i].courseName,
score:data.data[i].score
}
_this.yourscore.push(tmp);
}
}else {
_this.$msgbox('温馨提示',"当前没有可查询的成绩");
}
_this.$vux.loading.hide()
}
})
/* .catch(function (error) {
_this.$msgbox('温馨提示','系统内部异常，请联系管理员！');
})*/
},
download(){
var _this= this;
window.open('http:'+setting.api_root+'/api/exportOne?stuNumber='+_this.$store.state.stu_num,'_self')
},
}
}



// WEBPACK FOOTER //
// ./src/components/SearchScore.vue